import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getLogo } from './../../../assets/helper';

// import classnames from 'classnames';
import { Link } from 'react-router-dom';
import LanguagePicker from '../../../components/LanguagePicker/LanguagePicker';
import { ReactComponent as IconAvatarBG } from '../../../assets/imgs/icon-avatar-bg.svg';
import OrgPicker from '../../../components/OrgPicker/OrgPicker';

import * as actions from '../../../store/actions';

class Header extends Component {
  redirectToLogin = () => {
    this.props.history.push('/login');
  };


  isUK = () => (process.env.REACT_APP_STAGE === 'uk');

  openUpdateUserModal = () => {
    this.props.openModal({
      modalType: 'ADD_USER_MODAL',
      show: true,
      addUser: this.props.updateUser,
      user: this.props.userProfile,
      isUserProfile: true,
      closeModal: (e) => this.closeModal(e)
    });
  }

  closeModal = (e) => {
    // Prevent the form from submitting
    if (e) {
      e.preventDefault();
    }

    this.props.closeModal();
  }

  isUK() { return process.env.REACT_APP_STAGE === 'uk'; }

  render() {
    const { showLogo, showUser, showLang } = this.props;
    //const isMultiOrgUser = this.props.userProfile && this.props.userProfile['custom:orgId'] && typeof this.props.userProfile['custom:orgId'] === 'Array';
    const isMultiOrgUser = this.props.orgs && this.props.orgs.length && this.props.orgs.length > 1;
    console.log('isMultiOrgUser ', isMultiOrgUser);
    console.log('this.props.orgs: ', this.props.orgs);
    console.log('this.props.isAuthenticated: ', this.props.isAuthenticated);
    console.log('this.props.userProfile: ', this.props.userProfile);
    let name = '';
    if (this.props.isAuthenticated && this.props.userProfile) {
      name = `${this.props.userProfile.firstName} ${this.props.userProfile.lastName}`;
    }

    return (
      <header className="header">
        <div className="container">
          {showLogo ? (
            <>
              <div className="branding">
                <Link to={this.props.role ? "/admin" : "/survey"}>
                  <img className={'logo'} src={getLogo()} alt={'logo'} />
                </Link>

              </div>
              {showLang ? (
                <LanguagePicker />
              ) : null}
            </>
          ) : null}
          {showUser && this.props.isAuthenticated ? (
            <div className="user">
              <div className="userWrapper">
                <div className="username">{name}</div>
                {this.isUK() ? <br /> : <div className="role">{(this.props.realRole) ? this.props.realRole : this.props.role}</div>}
                {isMultiOrgUser ? <OrgPicker orgs={this.props.orgs} /> : null}
                <div className="logout">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a onClick={() => this.props.logout(this.redirectToLogin)}>Log out</a>
                </div>
              </div>
              <IconAvatarBG onClick={this.openUpdateUserModal} className="avatar clickable" />
            </div>
          ) : null}
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    role: state.auth.role,
    realRole: state.auth.realRole,
    userProfile: state.users.user,
    orgs: state.auth.orgs,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: cb => dispatch(actions.logout(cb)),
    openModal: (modalProps) => dispatch(actions.openModal(modalProps)),
    closeModal: () => dispatch(actions.closeModal()),
    updateUser: (userId, values, isUserProfile) => dispatch(actions.updateUser(userId, values, isUserProfile)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Header),
);
